import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
// import victor from '../../../assets/images/carbon_flash.png'
const ApplyModal = ({ setShow, show, Info }) => {
 
    return (
        <>

            <Modal
                show={show}
                centered
                backdrop="static"
                onHide={() => setShow(false)}
                className="modal-bgstyle"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title id="example-custom-modal-styling-title"  >


                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="d-flex align-items-start  ">
                        <div className="alt-icn  pe-2 ">
                            <img src={Info?.hover_icon?.url} alt="" />
                        </div>
                        <div className=" d-flex  flex-column alt-header ps-2 ">
                            <h1 className="primary-text primary-fnt    fw-bold">{Info?.title1[0]?.text}</h1>
                            <p className="">{Info?.modal_subtitle[0]?.text}s </p>
                        </div>

                    </div>
                    <div className="alt-details-body text-muted pt-4  px-3">

                        <h5>{Info?.modal_time[0]?.text}</h5>


                        <small className="d-block pb-4">{Info?.modal_description[0]?.text}</small>

                        <a target="_blank"
                            href={Info?.link[0].text}
                            className="text-decoration-none">
                            <button className="primary-btn  ">
                                APPLY NOW
                                </button>
                        </a>

                    </div>

                </Modal.Body>
            </Modal>
        </>


    );
};

export default ApplyModal;